import { Component, EventEmitter, OnChanges, Output, SimpleChanges } from '@angular/core';
import { AbstractDynamicReportViewComponent } from '../../abstract/abstract-dynamic-report-view.component';
import { DataObject, ReportRecord } from '../../models/report.model';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { onDrop } from './summary-view.helper';
import { InterpolatedBlueprint } from '../../models/blueprint.model';
import { TemplateField } from '../../models/template.model';
import { PROPERTY_MAP_ADDRESS } from './summary-view.model';
import { groupByProperty } from '../../shared/utils/group-by-property';

@Component({
  selector: 'rep-summary-view',
  templateUrl: './summary-view.component.html',
  styleUrls: ['./summary-view.component.scss'],
  standalone: false,
})
export class SummaryViewComponent extends AbstractDynamicReportViewComponent implements OnChanges {
  @Output() removeRecord: EventEmitter<ReportRecord> = new EventEmitter<ReportRecord>();
  @Output() reportReordered: EventEmitter<any> = new EventEmitter();
  summaryAddressPaths: DataObject;
  summaryRecords: ReportRecord[] = [];

  bodyFields: TemplateField[];

  protected prepareGroupsObjectToDisplay(interpolatedBlueprint: InterpolatedBlueprint) {
    super.prepareGroupsObjectToDisplay(interpolatedBlueprint);
    if (this.bodyGroups.length) {
      this.bodyFields = [].concat(...(this.bodyGroups || []).map(group => group.fields));
    }
  }

  ngOnChanges({ columns, currentView, reportLocale, reportData, reportOptions: _reportOptions }: SimpleChanges) {
    super.ngOnChanges({ columns, currentView, reportLocale, reportData });
    if (this.reportOptions.groupByBuilding) {
      this.summaryRecords = groupByProperty(this.reportData.records) as ReportRecord[];
      this.summaryRecords.forEach((record, index) => {
        record.position = index + 1;
      });
    } else {
      this.summaryRecords = this.reportData.records;
    }
    this.getAddressMaps();
  }

  removeRecordFromReport(reportItem: ReportRecord, recordIndex: number) {
    const recordId = reportItem.recordId ? reportItem.recordId : reportItem.data[recordIndex].recordId;
    this.removeRecord.emit({ ...reportItem, recordId });
  }
  onReorder(cdkDragDropEvent: CdkDragDrop<Array<{ [key: string]: any }>>) {
    onDrop(cdkDragDropEvent, this.reportData.records, this.reportReordered);
  }

  private getAddressMaps() {
    this.summaryAddressPaths = {
      postalAddress: this.reportData.entity
        ? PROPERTY_MAP_ADDRESS[this.reportData.entity]
        : PROPERTY_MAP_ADDRESS.property,
    };
  }
}
